module.exports = __webpack_public_path__ + "Material-Design-Iconic-Font.b351bd62abcd96e924d9.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/material-design-iconic-font/Material-Design-Iconic-Font.ttf?v=2.2.0
// module id = 1851
// module chunks = 19